import '../styles/main.scss';
import { effect1 } from './effect_1';
import { effect2 } from './effect_2'; 
import { effect3 } from './effect_3'; 
import { effect4 } from './effect_4';
window.addEventListener('DOMContentLoaded', () => {
    effect1();
    effect2();
    effect3();
    effect4();
    
});






